import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightLong, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faInstagram, faFacebook, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import FadeSection from "./utils/anim";
import Typewriter from 'typewriter-effect';
import { motion } from "motion/react";
//import AuraBackground from "./ui/aura-background";

function Bio({ lightMode }){

    const intro = React.useRef();
    
    const chatWithMe = () =>{
        window.open("https://wa.me/971545687890?text=Hello%20Niyaz,",'_blank');
    }

    return(
        <>
       {/* <AuraBackground> */} 
            <motion.div
                initial={{ opacity: 0.0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                delay: 0.3,
                duration: 0.8,
                ease: "easeInOut",
                }}
                className="relative flex flex-col gap-4 items-center justify-center px-4"
            >
        <div className={`md:custom-bio-md custom-bio overflow-none flex h-full items-center mx-auto ${lightMode ? "text-black" : "text-white"} w-11/12`}>
            
            <div className="grid grid-cols-1 md:pt-11 md:grid-cols-[2.5fr,1fr,2.5fr] gap-12 p-1">
                <div className="col-span-2  md:col-span-1 space-y-6 py-2 md:my-20">
                    
                    <div ref={intro} className="space-y-2">
                    <FadeSection effect="fade-right">
                        <h1 className="text-left text-5xl font-bold  ">
                            Hello,<br />
                            I'm <span className="text-4xl md:text-5xl text-red-500">Niyaz Ahamed</span>
                        </h1>
                        <h2 className="text-2xl text-left font-bold ">A Professional <span className="intro-text"><Typewriter options={{strings: ['Full stack developer', 'And Web Developer'], cursorClassName:"custom_cursor", loop: true, autoStart: true, cursor: "_"}}/></span></h2>
                        </FadeSection>
                    </div>
                    
                    <FadeSection effect="fade-in-down">
                        <div className="social-icons">
                            <div className="flex flex-col  py-6 rounded-lg">
                                <h2 className={`text-left ${lightMode ? "text-black" :"text-gray-400"}  mb-4 tracking-wider font-medium`}>FIND ME IN</h2>
                                <div className="flex gap-4">
                                    <a 
                                        href="mailto:maayilniyas@gmail.com" rel="noreferrer" 
                                        className="p-3 bg-gray-800 rounded-lg transition-all duration-300 hover:bg-gray-700 hover:-translate-y-1">
                                        <FontAwesomeIcon className="third-color hover:lnd-social w-5 h-5 text-gray-400" icon={faEnvelope} />
                                    </a>
                                    <a 
                                        href="https://www.facebook.com/niyas.ahamed.94/" target="_blank" rel="noreferrer"
                                        className="p-3 bg-gray-800 rounded-lg transition-all duration-300 hover:bg-gray-700 hover:-translate-y-1">
                                        <FontAwesomeIcon className=" third-color  hover:fb-social w-5 h-5 text-gray-400" icon={faFacebook} />    
                                    </a>
                                    <a 
                                    href="https://www.instagram.com/niyaz_nizu/" target="_blank" rel="noreferrer"
                                    className="p-3 bg-gray-800 rounded-lg transition-all duration-300 hover:bg-gray-700 hover:-translate-y-1">
                                        <FontAwesomeIcon className="third-color hover:ig-social w-5 h-5 text-gray-400" icon={faInstagram} />
                                    </a>
                                    <a 
                                    href="https://www.linkedin.com/in/niyaz-ahamed-91878816b/" target="_blank" rel="noreferrer" 
                                    className="p-3 bg-gray-800 rounded-lg transition-all duration-300 hover:bg-gray-700 hover:-translate-y-1">
                                        <FontAwesomeIcon className="third-color hover:lnd-social w-5 h-5 text-gray-400" icon={faLinkedinIn} />
                                    </a>   
                                </div>
                            </div>
                        </div>
                    </FadeSection>
                  {/*   <div className="intro_text">
                    <svg viewBox="0 0 1320 300">
                        <text x="50%" y="50%" text-anchor="middle" className="animate-stroke">
                        Nizu        </text>
                    </svg>
                </div> */}
                    
                </div>
                <div className="col-span-0 hidden md:block  space-y-6 text-left"></div>
                <FadeSection effect="fade-left">
                    <div className="col-span-2 md:col-span-1 space-y-6 md:pt-4 my-10 text-left">
                        <div>
                        {/* <span className="text-red-500">Expert on</span> */} 
                            <h3 className="text-2xl font-semibold">Based in Dubai.</h3>
                            <p className={` ${lightMode ? "text-gray-900":"text-gray-400"}`}>More than 7 Years of experiance in Website designing, Web Application Development, RPA Development.</p>
                        </div>

                            <p className="text-lg">
                            If you are looking for a talent that can help you build your Website, Web Apps or Automate your complex process, then you are at the right place, 
                            let&apos;s connect. Hire me for Full time or Part time. 
                            </p>

                        <button onClick={chatWithMe} className="third-color-bg text-white px-2 py-2 rounded-lg !mt-10 group transition-all duration-300 flex items-center gap-2 hover:transition-transform hover:bg-red-500 transition-colors ml">
                            <p><span className="mr-10 font-bold">Chat With Me</span>
                            <span className="px-2 h-full align-center bg-gray-500 animate-bounceX rounded-md"><FontAwesomeIcon className="transition-transform transform group-hover:translate-x-1" icon={faArrowRightLong} /></span>
                            </p>
                        </button>
                        
                    {/* <a href="#" className="text-red-500 hover:underline inline-flex items-center gap-2">
                        Download CV
                        </a> */} 
                    </div>
                </FadeSection> 
            </div>
            
        </div>
        </motion.div>
        {/* </AuraBackground>   */}
        </>
    );
}

export default Bio;